import React, {useEffect} from 'react';
import {Controller} from "react-hook-form";
import {timezones} from "./TimezonesList";
import {Autocomplete, TextField} from "@mui/material";

export default function TimezoneSelect(
    {
        control, setValue, selectedValue, style, slotProps, inputLabelShrink = false,
        inputName = "timezone",
        updateOnChange = () => null,
        defaultValue = {timezone: "Etc/UTC", offset: "(GMT+00:00) UTC (no daylight saving)"}
    }
) {
    useEffect(() => {
        if (selectedValue === "") {
            let userSettings = localStorage.getItem("user-settings");
            let settings = JSON.parse(userSettings);
            if (userSettings?.timezone !== "") {
                timezones.forEach((timezone) => {
                    if (timezone?.timezone === settings?.timezone) {
                        setTimeout(() => {
                            setValue(inputName, timezone);
                        })
                    }
                });
            }
        } else {
            timezones.forEach((timezone) => {
                if (timezone?.timezone === selectedValue) {
                    setTimeout(() => {
                        setValue(inputName, timezone);
                    });
                }
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [setValue, inputName, selectedValue]);

    return (
        <Controller
            render={({field: {onChange, ...props}}) => {
                return (
                    <Autocomplete
                        id="timezone-select"
                        disableClearable
                        isOptionEqualToValue={(option, value) => option.timezone === value.timezone}
                        getOptionLabel={(option) => {
                            if (typeof option === "string") return option;
                            return option?.offset || option?.timezone || "";
                        }}
                        options={timezones}
                        slotProps={slotProps}
                        renderInput={params => (
                            <TextField
                                {...params}
                                variant="outlined"
                                margin="dense"
                                label="Timezone"
                                size="small"
                                slotProps={inputLabelShrink ? {inputLabel: {shrink: true}} : undefined}
                                sx={style}
                            />
                        )}
                        onChange={(_, data) => {
                            onChange(data);
                            updateOnChange();
                        }}
                        {...props}
                    />
                )
            }}
            name={inputName}
            control={control}
            defaultValue={defaultValue}
            onChange={([, data]) => data}
        />
    );
}
